import { ProgressRingComponent } from './components/progress-ring/progress-ring.component';
import { events } from './events';
import { Module } from './framework/module';

export class ProgressModule extends Module {
  private progress$ = document.querySelector<HTMLDivElement>('#progress');
  private entries =
    document.querySelectorAll<HTMLParagraphElement>('#progress .log p');
  private log$ = document.querySelector<HTMLDivElement>('#progress .log');
  private eta$ = document.querySelector<HTMLDivElement>('#progress .eta');
  private ring$ = document.querySelector<ProgressRingComponent>(
    '#progress app-progress-ring'
  );

  async onInit() {
    events.on('open', (event) => this.onOpen(event));
    events.on('progress-info', (event) => this.onInfo(event));
    events.on('progress-eta', (event) => this.onEta(event));
    events.on('progress', (event) => this.onProgess(event));
    events.on('convert-finished', () =>
      this.onConvertFinishedOrProgressClose()
    );
    events.on('progress-close', () => this.onConvertFinishedOrProgressClose());
  }

  private onInfo({ text }: { text: string }) {
    const entry = document.createElement('p');
    entry.textContent = text;
    this.log$?.prepend(entry);
  }

  private toNiceEta(seconds: number) {
    if (seconds < 10) {
      return `${seconds.toFixed(2)} seconds`;
    } else if (seconds < 60) {
      return `${Math.round(seconds)} seconds`;
    } else {
      const minutes = Math.round(seconds / 60);
      const remainingSeconds = Math.floor(seconds % 60);

      if (minutes === 0) {
        return `${remainingSeconds} seconds`;
      }

      return `${minutes} minutes and ${remainingSeconds} seconds`;
    }
  }

  private onEta({ seconds }: { seconds: number }) {
    if (this.eta$ !== null && this.eta$ !== undefined) {
      this.eta$.textContent = this.toNiceEta(seconds);
    }
  }

  private onProgess({ percent }: { percent: number }) {
    if (percent >= 0 && percent <= 100) {
      this.ring$?.setProgress(percent);
    }
  }

  private onOpen(e: { files: FileList }) {
    this.show();
  }

  private onConvertFinishedOrProgressClose() {
    this.hide();
  }

  private show() {
    this.clearLog();

    this.progress$?.classList?.add('show');
  }

  private hide() {
    this.progress$?.classList?.remove('show');
  }

  private clearLog() {
    this.entries?.forEach((entry) => entry.remove());
  }
}
